import React from 'react';
import { Select } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useLanguage } from '../i18n/LanguageContext';
import { Language } from '../i18n/translations';

const { Option } = Select;

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  const handleLanguageChange = (value: Language) => {
    setLanguage(value);
  };

  return (
    <Select
      value={language}
      onChange={handleLanguageChange}
      style={{ width: 120 }}
      bordered={false}
      dropdownStyle={{ minWidth: 120 }}
    >
      <Option value="en">
        <GlobalOutlined style={{ marginRight: 8 }} />
        English
      </Option>
      <Option value="zh">
        <GlobalOutlined style={{ marginRight: 8 }} />
        中文
      </Option>
      <Option value="de">
        <GlobalOutlined style={{ marginRight: 8 }} />
        Deutsch
      </Option>
      <Option value="pt">
        <GlobalOutlined style={{ marginRight: 8 }} />
        Português
      </Option>
    </Select>
  );
};

export default LanguageSwitcher; 